import { render } from "./Highlight.vue?vue&type=template&id=71a58b58"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__